import { analytics } from 'utils/analytics';
import { HeaderAddressAnalyticsElementText } from '../../components/city-picker/utils';

export type HeaderAnalyticsElementText =
  | 'logo'
  | 'sideMenu'
  | 'search'
  | 'account'
  | 'shoppingList'
  | 'basket'
  | HeaderAddressAnalyticsElementText;

export const headerAnalyticsEventDetailBase = {
  elementType: 'button',
  elementBlock: 'header',
  elementName: 'header',
};

export const useHeaderAnalyticsEvent = (elementText: HeaderAnalyticsElementText) => () =>
  analytics.sendEvent('GA:clickButton', {
    ...headerAnalyticsEventDetailBase,
    elementText,
  });
